import styled from '@emotion/styled';
import { font, remCalc, mediaQueries } from '../../css';

const StyledWrapper = styled('div')(
    () => ({
        position: 'absolute',
        display: 'flex',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        [mediaQueries.medium]: {
            height: '100%',
        },
    }),
    ({ isFocused, theme }) => ({
        zIndex: isFocused ? 3 : -1,
        backgroundColor: theme.guide.activeSlideTextColor,
    }),
);

const StyledButton = styled('button')(
    ({ theme }) => ({
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        height: '100%',
        fontWeight: font.weight.medium,
        fontSize: font.size.xs,
        lineHeight: font.lineHeight.xs,
        color: theme.guide.activeSlideColor,
        textDecoration: 'none',
        [mediaQueries.medium]: {
            height: '100%',
            fontSize: remCalc(21),
            lineHeight: font.lineHeight.s,
        },
    }),
    ({ focusStyle, theme }) => ({
        ...focusStyle,
        backgroundColor: theme.guide.activeSlideTextColor,
        transition: 'border-color 0.3s linear',
        ':focus,:hover': {
            borderColor: theme.guide.activeSlideColor,
            color: theme.guide.activeSlideColor,
        },
    }),
);

export { StyledButton, StyledWrapper };
